/* eslint-disable indent */
/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import { withRouter } from 'react-router';
import {
  TextInput,
  Dropdown,
  Icons,
  Button,
  Dialog,
} from '@techsoftware/happay-widgets';
import NumberFormat from 'react-number-format';
import history from '../../utils/history';
import CustomTabs from '../customComponent/customTabs';
import GenericHeader from '../../containers/GenericHeaderContainer';
import ValidationPolicy from '../customComponent/validationPolicy';
import KYC from '../../containers/kycContainer';
import Locales from '../../constants/locales';
import Animation from '../animation';
const SignupConstants = Locales.JSON.signup;

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordDialog: false,
      mobileNoDialog: false,
      nameDialog: false,
      resetData: {
        otp: '',
        new_passwd: '',
        confirmPassword: '',
      },
      passwordValidationList: {
        capital: '',
        special: '',
        length: '',
      },
      openValidationPopup: false,
      otpValidation: '',
      passwordValidation: '',
      cpasswordValidation: '',
      comparepasswordValidation: '',
      changeMobileNoAllState: {
        countryCode: '+91',
        mobileNo: '',
        ccEmail: '',
        pass: '',
        otp: '',
        fname: '',
        lname: '',
      },
    };
    this.onChange = this.onChange.bind(this);
    this.openPasswordDialog = this.openPasswordDialog.bind(this);
    this.generateOTP = this.generateOTP.bind(this);
    this.proceedReset = this.proceedReset.bind(this);
    this.updateAllState = this.updateAllState.bind(this);
    this.proceedChangeMobileNo = this.proceedChangeMobileNo.bind(this);
    this.nameChangeSubmit = this.nameChangeSubmit.bind(this);
    this.onNameEdidClose = this.onNameEdidClose.bind(this);
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.withOTP) {
      this.openPasswordDialog();
    }
    this.props.getuserinfo();
    this.props.getCountryCodes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.auth.passwordReset !== this.props.auth.passwordReset) {
      /* this.setState({
        passwordDialog: false,
      }); */
      this.openPasswordDialog();
    }
  }

  onChange(event, value, type) {
    const dataSet = { ...this.state.resetData };
    const { passwordValidationList } = this.state;
    dataSet[type] = value;

    if (type === 'new_passwd') {
      const regexCapital = /^(?=.*[A-Z]).*$/;
      const regexSpecial = /^(?=.*\W).*$/;
      if (regexCapital.test(value)) {
        passwordValidationList.capital = '';
      } else {
        passwordValidationList.capital =
          'Password must contain atleast 1 uppercase letter';
      }
      if (regexSpecial.test(value)) {
        passwordValidationList.special = '';
      } else {
        passwordValidationList.special =
          'Password must contain atleast 1 special character';
      }
      if (value.length > 6) {
        passwordValidationList.length = '';
      } else {
        passwordValidationList.length =
          'Password should be of atleast 6 characters';
      }
    }
    this.setState({
      resetData: dataSet,
      passwordValidationList,
      openValidationPopup: type === 'new_passwd' && value,
      otpValidation: '',
      passwordValidation: '',
      cpasswordValidation: '',
      comparepasswordValidation: '',
    });
  }

  changeMobileNoUpdateState(value, type) {
    const allstate = { ...this.state.changeMobileNoAllState };
    allstate[type] = value;
    this.setState({ changeMobileNoAllState: allstate });
  }

  selectedCountryCode(value) {
    const { auth } = this.props;
    const allstate = { ...this.state.changeMobileNoAllState };
    allstate.countryCode = auth.countryCodes[value].value;
    this.setState({ changeMobileNoAllState: allstate });
  }

  openPasswordDialog() {
    this.setState({
      passwordDialog: !this.state.passwordDialog,
    });
  }

  generateOTP() {
    this.props.resetWithOTP();
  }

  // eslint-disable-next-line consistent-return
  proceedReset(event) {
    event.preventDefault();
    const finalData = { ...this.state.resetData };
    if (finalData.otp === '') {
      this.setState({
        otpValidation: 'OTP should not be empty',
      });
      return -1;
    }
    if (finalData.new_passwd === '') {
      this.setState({
        passwordValidation: 'Password should not be empty',
      });
      return -1;
    }
    if (finalData.new_passwd.length < 6) {
      this.setState({
        passwordValidation: 'Password should be of atleast 6 characters',
      });
      return -1;
    }
    if (finalData.confirmPassword === '') {
      this.setState({
        cpasswordValidation: 'Confirm password should not be empty',
      });
      return -1;
    }
    if (finalData.new_passwd !== finalData.confirmPassword) {
      this.setState({
        comparepasswordValidation: 'Password & Confirm password must be same',
      });
      return -1;
    }
    this.props.resetPassword(this.state.resetData);
  }

  proceedChangeMobileNo(event) {
    event.preventDefault();
    const { userInfo = {}, auth } = this.props;
    const finalData = { ...this.state.changeMobileNoAllState };
    const queryObj = {};
    if (
      !finalData.mobileNo ||
      (finalData.mobileNo && finalData.mobileNo.length < 10)
    ) {
      this.props.showSnackbar({
        msg: 'Please enter valid mobile number',
        type: 'error',
      });
      return false;
    }
    if (!finalData.pass) {
      this.props.showSnackbar({
        msg: 'Please enter valid password',
        type: 'error',
      });
      return false;
    }
    queryObj.mobile_extension = finalData.countryCode;
    queryObj.mobile_number = finalData.mobileNo;
    queryObj.cc = finalData.ccEmail;
    if (finalData.otp) {
      queryObj.field = 'mobile_number';
      queryObj.user_id = userInfo.happay_id;
      queryObj.otp = finalData.otp;
      queryObj.password = finalData.pass;
      this.props.editMobileNo(queryObj);
    } else {
      this.props.mncResetWithOTP(queryObj);
    }
  }

  nameChangeSubmit(event) {
    event.preventDefault();
    const { userInfo = {}, auth } = this.props;
    const finalData = { ...this.state.changeMobileNoAllState };
    const queryObj = {};
    if (!finalData.fname) {
      this.props.showSnackbar({
        msg: 'Please enter first name',
        type: 'error',
      });
      return false;
    }
    if (!finalData.lname) {
      this.props.showSnackbar({
        msg: 'Please enter last name',
        type: 'error',
      });
      return false;
    }
    queryObj.first_name = finalData.fname;
    queryObj.last_name = finalData.lname;
    queryObj.gender = userInfo.gender;
    queryObj.dob = userInfo.dob;
    this.props.editName(queryObj);
  }

  handleResend() {
    const finalData = { ...this.state.changeMobileNoAllState };
    const queryObj = {};
    queryObj.mobile_extension = finalData.countryCode;
    queryObj.mobile_number = finalData.mobileNo;
    queryObj.cc = finalData.ccEmail;
    this.props.mncResetWithOTP(queryObj);
  }

  getHeaderConfig = () => {
    const obj = {};
    obj.crossButton = {
      type: 'crossButton',
    };
    return obj;
  };

  onButtonClick = (event, type) => {
    if (type.type === 'crossButton') {
      history.push('/dashboard');
    } else {
      history.goBack();
    }
  };

  updateAllState(event) {
    this.props.getuserinfo();
    this.props.resetMobileNoSuccess({});
    this.props.mncResetOTPSent(false);
    const { mobileNoDialog, nameDialog } = this.state;
    const mobileDialogState = { ...this.state.changeMobileNoAllState };

    mobileDialogState.countryCode = '+91';
    mobileDialogState.mobileNo = '';
    mobileDialogState.ccEmail = '';
    mobileDialogState.pass = '';
    mobileDialogState.otp = '';
    mobileDialogState.fname = '';
    mobileDialogState.lname = '';
    this.setState({
      mobileNoDialog: mobileNoDialog ? !mobileNoDialog : mobileNoDialog,
      nameDialog: nameDialog ? !nameDialog : nameDialog,
      changeMobileNoAllState: mobileDialogState,
    });
    event.preventDefault();
    event.stopPropagation();
  }

  onNameEdidClose(event) {
    this.props.getuserinfo();
    this.props.nameEditSuccess(false);
    const { nameDialog } = this.state;
    const mobileDialogState = { ...this.state.changeMobileNoAllState };

    mobileDialogState.countryCode = '+91';
    mobileDialogState.mobileNo = '';
    mobileDialogState.ccEmail = '';
    mobileDialogState.pass = '';
    mobileDialogState.otp = '';
    mobileDialogState.fname = '';
    mobileDialogState.lname = '';
    this.setState({
      nameDialog: nameDialog ? !nameDialog : nameDialog,
      changeMobileNoAllState: mobileDialogState,
    });
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    const { userInfo = {}, auth } = this.props;
    const { changeMobileNoAllState } = this.state;
    return (
      <Grid xs={24}>
        <GenericHeader
          title={`${userInfo.first_name || ''} ${userInfo.last_name || ''}`}
          showBreadcrumbs={false}
          headerconfig={this.getHeaderConfig()}
          onButtonClick={this.onButtonClick}
          from ='invoice'
        />
        {userInfo && (
          <Grid
            container
            justify="center"
            alignItems="flex-start"
            className="app-background"
          >
            <Grid item xs={16} md={20} sm={20} lg={16} xl={16}>
              <Grid className="bordered-container margin-t-20 margin-b-20 padding-30">
                <Grid
                  container
                  xs={24}
                  direction="row"
                  className="padding-b-20"
                >
                  <Grid
                    item
                    xs={12}
                    container
                    direction="column"
                    alignItems="flex-start"
                  >
                    <span className="info-text regular">Name</span>
                    <div>
                      <span className="body dark">{`${userInfo.first_name} ${userInfo.last_name}`}</span>
                      <span>
                        <Icons
                          onClick={() => {
                            this.setState({ nameDialog: true });
                          }}
                          type="edit"
                          size="small"
                          className="margin-l-10 primary green-color"
                        />
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    direction="column"
                    alignItems="flex-start"
                  >
                    <span className="info-text regular">Password</span>
                    <div>
                      <span className="body dark">***********</span>
                      <span
                        className="hw-link-button-primary margin-l-10"
                        onClick={this.openPasswordDialog}
                      >
                        Change password
                      </span>
                    </div>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={24}
                  container
                  direction="column"
                  className="padding-b-30"
                  alignItems="flex-start"
                >
                  <span className="info-text regular">Email Id</span>
                  <span className="body dark">{userInfo.email_id}</span>
                </Grid>
                <Grid
                  item
                  xs={24}
                  container
                  direction="column"
                  alignItems="flex-start"
                >
                  <span className="info-text regular">Phone no.</span>
                  <div>
                    <span className="body dark">{`${userInfo.mobile_extension} ${userInfo.mobile_number}`}</span>
                    <span>
                      <Icons
                        onClick={() => {
                          this.setState({ mobileNoDialog: true });
                        }}
                        type="edit"
                        size="small"
                        className="margin-l-10 primary green-color"
                      />
                    </span>
                  </div>
                </Grid>
              </Grid>
              {/* {Object.keys(userInfo).length &&
              userInfo.cards.length &&
              userInfo.cards[0].is_happay_switch ? (
                <div>
                  <CustomTabs tabName={['KYC']} onTabChange={() => {}} />
                  <KYC userInfo={userInfo || {}} />
                </div>
              ) : null} */}
            </Grid>
          </Grid>
        )}

        <Dialog
          id="changePassDialog"
          // aria-labelledby="customized-dialog-title"
          open={this.state.passwordDialog}
          onClose={this.openPasswordDialog}
          // maxWidth="md"
          bodyStyle={{ padding: '30px' }}
          width={this.state.openValidationPopup ? '42%' : '28%'}
          onBackdropClick={() => {
            this.setState({
              passwordDialog: false,
            });
          }}
          crossIcon
          title="Change password"
        >
          <form onSubmit={this.proceedReset}>
            <Grid
              container
              justify="center"
              item
              xs={this.state.openValidationPopup ? 14 : 24}
              alignItems="center"
              style={{
                width: this.state.openValidationPopup ? '630px' : '350px',
              }}
            >
              <Grid item xs={14}>
                <div className="margin-t-10 margin-b-10">
                  <TextInput
                    floatingLabelText="One Time Password (OTP)"
                    type="text"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'otp')
                    }
                    value={this.state.resetData.otp}
                    hintText="Enter OTP"
                    clearMargin="true"
                    errorType={this.state.otpValidation ? 'error' : ''}
                    errorText={this.state.otpValidation}
                  />
                </div>
              </Grid>
              <Grid item xs={10}>
                <div className="padding-l-10 padding-b-6">
                  <Button
                    type="button"
                    text="Generate OTP"
                    variant="primary"
                    size="medium"
                    fullWidth
                    // className="button dark noOpac"
                    buttonParentStyles={{ padding: '10px' }}
                    onClick={this.generateOTP}
                  />
                </div>
              </Grid>
              <Grid item xs={24}>
                <div className="margin-t-10 margin-b-10 pos-relative">
                  <TextInput
                    floatingLabelText="New Password"
                    type="text"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'new_passwd')
                    }
                    value={this.state.resetData.new_passwd}
                    hintText="Enter your password"
                    customInputParentStyle={{
                      width: '100%',
                      fontSize: '12px',
                    }}
                    // clearMargin="true"
                    showEyeIcon={this.state.resetData.new_passwd}
                    errorText={this.state.passwordValidation}
                  />
                  <div style={{ position: 'absolute', left: '104%' }}>
                    <ValidationPolicy
                      passwordValidationList={this.state.passwordValidationList}
                      openValidationPopup={this.state.openValidationPopup}
                    />
                  </div>
                  {/* Password */}
                </div>
                <div className="margin-t-10 margin-b-10">
                  <TextInput
                    floatingLabelText="Confirm password"
                    type="text"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'confirmPassword')
                    }
                    value={this.state.resetData.confirmPassword}
                    hintText="Confirm your password"
                    customInputParentStyle={{
                      width: '100%',
                      fontSize: '12px',
                    }}
                    // clearMargin="true"
                    showEyeIcon={this.state.resetData.confirmPassword}
                    errorText={
                      this.state.cpasswordValidation ||
                      this.state.comparepasswordValidation
                    }
                  />
                  {/* Confirm Password */}
                </div>
                <Button
                  type="submit"
                  text="Done"
                  variant="primary"
                  size="medium"
                  fullWidth
                  className="noOpac margin-b-10"
                  style={{ width: '100%' }}
                />
              </Grid>
            </Grid>
          </form>
        </Dialog>

        {/* below dialog is for mobile no change */}
        <Dialog
          // aria-labelledby="customized-dialog-title"
          id="mobileNoDialog"
          open={this.state.mobileNoDialog}
          onClose={this.updateAllState}
          // maxWidth="md"
          width="28%"
          bodyStyle={{ padding: '30px' }}
          onBackdropClick={() => {
            this.setState({
              mobileNoDialog: false,
            });
          }}
          crossIcon={
            !(auth && auth.mobileNoReset && auth.mobileNoReset.success)
          }
          title={
            auth && auth.mncResetOTPSent
              ? auth && auth.mobileNoReset && auth.mobileNoReset.success
                ? ' '
                : 'Enter OTP'
              : 'Change phone number'
          }
        >
          <form onSubmit={this.proceedChangeMobileNo}>
            <Grid
              container
              justify="center"
              item
              xs={24}
              alignItems="center"
              style={{
                width: '350px',
              }}
            >
              {auth && auth.mncResetOTPSent ? (
                auth && auth.mobileNoReset && auth.mobileNoReset.success ? (
                  <>
                    <Animation
                      type="confetti"
                      autoPlay
                      height={200}
                      width={200}
                    />
                    <Grid item xs={24} container justify="center">
                      <div className="body dark fw-600 margin-t-10 margin-b-10">
                        Phone number successfully changed
                      </div>
                    </Grid>
                    <Grid item xs={24} container justify="center">
                      <div
                        className="status green pointer fw-700 font-12 margin-l-10"
                        onClick={() => {}}
                      >
                        Okay, got it{' '}
                      </div>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={24}>
                      <div className="body margin-t-10 margin-b-10">
                        {' '}
                        We have sent an OTP on the new phone number, you just
                        saved.{' '}
                      </div>
                    </Grid>
                    <Grid item xs={24}>
                      <div className="margin-t-10">
                        <TextInput
                          floatingLabelText="One Time Password (OTP)"
                          type="text"
                          onChange={(event, value) =>
                            this.changeMobileNoUpdateState(value, 'otp')
                          }
                          value={changeMobileNoAllState.otp}
                          hintText="Enter OTP"
                          clearMargin="true"
                          errorText={
                            (auth &&
                              auth.mobileNoReset &&
                              auth.mobileNoReset.res_str) ||
                            ''
                          }
                        />
                      </div>
                    </Grid>
                    <Grid item xs={24} container justify="flex-end">
                      <div className="status margin-b-10">
                        <span> Didn’t get the code? </span>
                        <span
                          className="status green pointer fw-700 font-12 margin-l-10"
                          onClick={event => {
                            this.handleResend();
                            event.preventDefault();
                            event.stopPropagation();
                          }}
                        >
                          Resend OTP{' '}
                        </span>
                      </div>
                    </Grid>
                    <Grid item xs={24}>
                      <Button
                        type="submit"
                        text="Done"
                        fullWidth
                        variant="primary"
                        size="medium"
                        className="noOpac margin-b-10"
                        // style={{ width: '100%' }}
                      />
                    </Grid>
                  </>
                )
              ) : (
                <>
                  <Grid item xs={8}>
                    <Dropdown
                      isMultiSelect={false}
                      data={(auth && auth.countryCodes) || []}
                      value={changeMobileNoAllState.countryCode}
                      selectValueLabel="+91"
                      customDropdownStyle={{
                        width: '100%',
                      }}
                      labelText="Country code"
                      onChange={(event, value) =>
                        this.selectedCountryCode(value)
                      }
                      clearMargin="true"
                    />
                  </Grid>
                  <Grid item xs={16}>
                    <div className="margin-t-10 margin-l-10">
                      <NumberFormat
                        floatingLabelText="New phone number"
                        type="tel"
                        format={SignupConstants.NUMBER_FORMAT}
                        placeholder={SignupConstants.PHONE_PLACEHOLDER}
                        hintText={SignupConstants.PHONE_PLACEHOLDER}
                        value={changeMobileNoAllState.mobileNo}
                        isNumericString
                        customInput={TextInput}
                        onValueChange={values => {
                          this.changeMobileNoUpdateState(
                            values.value,
                            'mobileNo',
                          );
                        }}
                        customInputParentStyle={{
                          width: '100%',
                          fontSize: '12px',
                        }}
                        clearMargin="true"
                        displayType="input"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={24}>
                    <div className="margin-t-10">
                      <TextInput
                        floatingLabelText="Sign in password"
                        type="text"
                        onChange={(event, value) => {
                          this.changeMobileNoUpdateState(value, 'pass');
                        }}
                        value={changeMobileNoAllState.pass}
                        hintText=" "
                        customInputParentStyle={{
                          width: '100%',
                          fontSize: '12px',
                        }}
                        clearMargin="true"
                        showEyeIcon={changeMobileNoAllState.pass}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={24}>
                    <div className="margin-t-10">
                      <TextInput
                        floatingLabelText="Email for cc"
                        type="email"
                        name="email"
                        onChange={(event, value) => {
                          this.changeMobileNoUpdateState(value, 'ccEmail');
                        }}
                        value={changeMobileNoAllState.ccEmail}
                        customInputParentStyle={{
                          width: '100%',
                          fontSize: '12px',
                        }}
                        clearMargin="true"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={24}>
                    <Button
                      type="submit"
                      text="Save"
                      fullWidth
                      variant="primary"
                      size="medium"
                      className="noOpac margin-t-10"
                      // style={{ width: '100%' }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </form>
        </Dialog>
        <Dialog
          // aria-labelledby="customized-dialog-title"
          id="changeNameDialog"
          open={this.state.nameDialog}
          onClose={this.onNameEdidClose}
          // maxWidth="md"
          width="392px"
          actions={false}
          bodyStyle={{ padding: '0px 30px 30px 30px', marginBottom: '0px' }}
          onBackdropClick={() => {
            this.setState({
              nameDialog: false,
            });
          }}
          crossIcon
          title="Change Name"
        >
          <form onSubmit={this.nameChangeSubmit}>
            {auth && auth.nameEditSuccess ? (
              <>
                <Animation type="confetti" autoPlay height={200} width={200} />
                <Grid item xs={24} container justify="center">
                  <div className="body dark fw-600 margin-t-10 margin-b-10">
                    Name changed successfully!
                  </div>
                </Grid>
                <Grid item xs={24} container justify="center">
                  <div
                    className="status green pointer fw-700 font-12 margin-l-10"
                    onClick={this.onNameEdidClose}
                  >
                    Okay, got it{' '}
                  </div>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={24}>
                  <div className="margin-b-30 margin-t-10">
                    <TextInput
                      floatingLabelText="First Name"
                      type="text"
                      onChange={(event, value) => {
                        this.changeMobileNoUpdateState(value, 'fname');
                      }}
                      value={changeMobileNoAllState.fname}
                      hintText=" "
                      customInputParentStyle={{
                        width: '100%',
                        fontSize: '12px',
                      }}
                      clearMargin="true"
                      showEyeIcon={changeMobileNoAllState.pass}
                    />
                  </div>
                  <div className="margin-b-30">
                    <TextInput
                      floatingLabelText="Last Name"
                      type="text"
                      onChange={(event, value) => {
                        this.changeMobileNoUpdateState(value, 'lname');
                      }}
                      value={changeMobileNoAllState.lname}
                      hintText=" "
                      customInputParentStyle={{
                        width: '100%',
                        fontSize: '12px',
                      }}
                      clearMargin="true"
                      showEyeIcon={changeMobileNoAllState.pass}
                    />
                  </div>
                </Grid>
                <Grid item xs={24}>
                  <Button
                    type="submit"
                    text="Save"
                    fullWidth
                    variant="primary"
                    size="medium"
                    className="noOpac margin-t-10"
                    // style={{ width: '100%' }}
                  />
                </Grid>
              </>
            )}
          </form>
        </Dialog>
      </Grid>
    );
  }
}

Profile.propTypes = {
  location: PropTypes.object,
  auth: PropTypes.object,
  userInfo: PropTypes.object,
  getuserinfo: PropTypes.func,
  resetWithOTP: PropTypes.func,
  resetPassword: PropTypes.func,
  getCountryCodes: PropTypes.func,
  mncResetWithOTP: PropTypes.func,
  editMobileNo: PropTypes.func,
  resetMobileNoSuccess: PropTypes.func,
  mncResetOTPSent: PropTypes.func,
  showSnackbar: PropTypes.func,
  editName: PropTypes.func,
  nameEditSuccess: PropTypes.func,
};

export default withRouter(Profile);
